// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Perspective_wrapper__NWOb0","glass":"Perspective_glass__3l5is"};